import { ErrorFallbackBase, ErrorFallbackProps } from './ErrorFallbackBase'

export const ErrorFallbackEmployee = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase
    {...props}
    primaryColorClass="primaryEmployee"
    homeUrl="/"
    title="Ups! Something went wrong"
    description="We found a problem while loading your information. Don't worry, your data is safe."
  />
)

export const ErrorFallbackAdmin = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase
    {...props}
    primaryColorClass="primaryAdmin"
    homeUrl="/admin/companies"
    title="Error in the administration panel"
    description="An error occurred in the administrative system. Please try again or contact the technical team."
  />
)

export const ErrorFallbackHR = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase
    {...props}
    primaryColorClass="primaryAdmin"
    homeUrl="/"
    title="Error in the HR system"
    description="There was a problem processing the information of your company. Let's try to load the data again."
  />
)

export const ErrorFallbackGeneric = (props: ErrorFallbackProps) => (
  <ErrorFallbackBase
    {...props}
    primaryColorClass="primaryEmployee"
    homeUrl="/"
    title="Something went wrong"
    description="We found an unexpected error. Please try again or contact our support team."
  />
)
